(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.ActiveDailyLiving",
                {
                    url: "/ActiveDailyLiving",
                    component: "activedailyliving",
                    PageTitle: "Active Daily Living",
                    requiredPermissions: "ActiveDailyLiving:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("activedailyliving",
        {
            templateUrl: "App/Resources/ActiveDailyLiving/activedailyliving.html",
            controller: activedailylivingCtrl,
            bindings: {
                states: "<"               
            }
        });

    activedailylivingCtrl.$inject = ["amplitudeService"];

    function activedailylivingCtrl(amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
    }
})(window.app, window.angular); // jshint ignore:line